<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('devices.station_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-xs-2 col-sm-6 col-md-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.order')}: *`"
          v-model="model.order"
          name="common_words.order"
          v-validate="modelValidations.order"
          :error="getError('common_words.order', true)"
          placeholder="1"
        ></fg-input>
      </div>
      <div class="col-sm-6 col-md-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.code_serial')}: *`"
          v-model="model.code_station"
          name="common_words.code"
          v-validate="modelValidations.code_station"
          :error="getError('common_words.code', true)"
          placeholder="FHg56#g67BcaeF5"
          maxlength="100"
        ></fg-input>
      </div>
      <select-component
        rowClass="col-sm-6 col-md-3"
        :labelSelect="`${$t('common_words.type')}: *`"
        :isMultiple="false"
        :dataOptions="types"
        :initialSelection="model.station_type_id"
        @onChange="handleChangeSelected"
        modelName="station_type_id"
        requireClass="required-station-type"
      />
      <select-component
        rowClass="col-sm-6 col-md-3"
        :labelSelect="`${$t('devices.brand')}: *`"
        :isMultiple="false"
        :dataOptions="marks"
        :initialSelection="model.station_mark_id"
        @onChange="handleChangeSelected"
        modelName="station_mark_id"
        requireClass="required-station-mark"
      />
      <div class="col-2">
        <div class="form-group has-label">
          <label for="">¿{{ $t('common_words.api_request') }}?: *</label>
          <br />
          <el-select
            filterable
            class="select-primary mb-3 shadow-sm required-firstStep"
            v-model="model.is_request"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              class="select-primary"
              v-for="item in [
                { id: 0, value: 'NO' },
                { id: 1, value: 'SI' },
              ]"
              :key="item.id + item.value"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('devices.station_name')}...`"
        ></fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.alias')} *`"
          v-model="model.name2"
          name="common_words.alias"
          v-validate="modelValidations.name2"
          :error="getError('common_words.alias', true)"
          :placeholder="`${$t('devices.station_alias')}...`"
        ></fg-input>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import store from '@/store';

export default {
  data() {
    return {
      types: [],
      marks: [],
      model: {
        name: null,
        code_station: null,
        order: null,
        is_request: 0,
        name2: null,
        station_type_id: null,
        station_mark_id: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        code_station: {
          required: true,
          max: 10,
        },
        order: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        if (!res) return false;
        if (
          !this.model.station_type_id ||
          this.model.station_type_id.length == 0
        ) {
          return store.dispatch(
            'utils/validationInputsRequired',
            '-station-type'
          );
        } else if (
          !this.model.station_mark_id ||
          this.model.station_mark_id.length == 0
        ) {
          return store.dispatch(
            'utils/validationInputsRequired',
            '-station-mark'
          );
        } else {
          this.$emit('on-validated', res, this.model);
          const typeSelected = this.types.find(
            (type) => type.id === this.model.station_type_id
          );
          const markSelected = this.marks.find(
            (mark) => mark.id === this.model.station_mark_id
          );

          this.$emit('fillStationForm', 'firstStep', {
            station_type: typeSelected.name,
            station_mark: markSelected.name,
          });
          return res;
        }
      });
    },

    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('devices/stationtypes/select'),
        Axios.getMasters('devices/stationmarks/select'),
      ])
        .then((response) => {
          const [responseType, responseMark] = response;
          this.types = responseType.data.data;
          this.marks = responseMark.data.data;

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            const {
              code_station,
              name,
              order,
              is_request,
              name2,
              station_type_id,
              station_mark_id,
            } = JSON.parse(sessionStorage.getItem('editForm'));
            this.model = {
              ...this.model,
              code_station,
              name,
              order,
              is_request,
              name2,
              station_type_id,
              station_mark_id,
            };
          }
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },
};
</script>
<style></style>
